import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Terms & Conditions</h1>
        <p>Welcome to Satta Wala</p>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2>Introduction</h2>
          <p>
            These Terms and Conditions outline the rules and regulations for the
            use of <strong>Satta Wala</strong>'s website. By accessing this
            website, we assume you accept these terms. Do not continue to use
            Satta Wala if you do not agree to all of the terms stated here.
          </p>
        </section>

        <section className="terms-section">
          <h2>Use of Information</h2>
          <p>
            Satta Wala provides <strong>results, records, and updates</strong>
            related to satta games for informational purposes only. We do not
            encourage or promote actual gambling. Users are responsible for how
            they use the information shared on our website.
          </p>
        </section>

        <section className="terms-section">
          <h2>Cookies</h2>
          <p>
            We employ the use of cookies. By accessing Satta Wala, you agreed to
            use cookies in agreement with our Privacy Policy to enhance user
            experience.
          </p>
        </section>

        <section className="terms-section">
          <h2>External Links</h2>
          <p>
            Our website may contain links to third-party sites. We are not
            responsible for the content or practices of those external websites.
            Users should review the terms and privacy policies of third-party
            sites they visit.
          </p>
        </section>

        <section className="terms-section">
          <h2>Limitations of Liability</h2>
          <p>
            Satta Wala will not be held liable for any damages or losses arising
            from the use of information or services on our website. All content
            is provided "as is" without warranties of any kind.
          </p>
        </section>

        <section className="terms-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these terms at any time
            without prior notice. Continued use of the website means you accept
            the updated terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions regarding these Terms & Conditions, please
            contact us at:
          </p>
          <ul>
            <li>📧 Email: support@sattawalaonline.com</li>
            <li>📞 Phone / WhatsApp: +91-8799778497</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
